<template>
  <Header_en_m/>
  <Enterprise_index_en_m></Enterprise_index_en_m>
  <Enterprise_page_en_m></Enterprise_page_en_m>
  <Footer_en_m></Footer_en_m>
</template>

<script>
import Enterprise_index_m from "@/components/CN_mobile/enterprise/Enterprise_index_m";
import Enterprise_page_m from "@/components/CN_mobile/enterprise/Enterprise_page_m";
import Footer_m from "@/components/CN_mobile/Footer_m";
import Header_m from "@/components/CN_mobile/Header_m";
import Header_en_m from "@/components/EN_mobile/Header_en_m";
import Footer_en_m from "@/components/EN_mobile/Footer_en_m";
import Enterprise_index_en_m from "@/components/EN_mobile/enterprise/Enterprise_index_en_m";
import Enterprise_page_en_m from "@/components/EN_mobile/enterprise/Enterprise_page_en_m";
export default {
  name: 'Enterprise_en_m',
  components: {
    Enterprise_page_en_m,
    Enterprise_index_en_m, Footer_en_m, Header_en_m, Header_m, Enterprise_page_m, Enterprise_index_m,Footer_m},
}

</script>